import { Component, Input } from '@angular/core';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { ServiceTypeEnum } from '../../models/cartDetails/service-type.enum';
import { PromotionTypeEnum } from '../../models/cartDetails/promotionType.model';

@Component({
  selector: '[side-order-details-slot-addon]',
  templateUrl: './side-order-details-slot-addon.component.html',
})
export class SideOrderDetailsSlotAddonComponent {
  public addon: any = {};
  public isVirginBrand: boolean;

  @Input() public addonIndex: number;
  @Input() public ordinalNumber: number;
  @Input() public serviceType: ServiceTypeEnum;
  @Input() public promotionType: PromotionTypeEnum;
  @Input() set addonData(addon: any) {
    this.addon = addon;
  }

  constructor(
    private commonInfo: CommonInfoService,
  ) {
    this.isVirginBrand = this.commonInfo.isVirginBrand;
  }

  getStepAddonPrice(price: any): string {
    return price.price[this.commonInfo.taxName];
  }

  getMainAddonPrice(): string {
    return this.addon.priceInfos[0]?.prices[0]?.price[this.commonInfo.taxName] || '';
  }

  showPrice(): boolean {
    return this.addon.addonGroup !== 'obligatory' || this.addon.addonGroup === 'grouped';
  }

}
